import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      {/* Hero */}
      <section className="bg-navy text-white noise-overlay py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-gray-400 hover:text-bronze mb-6 transition-colors"
          >
            <ArrowLeft className="mr-2 w-4 h-4" />
            Back to Home
          </Link>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold">
            Privacy Policy
          </h1>
          <p className="font-body text-gray-400 mt-4">
            Last updated: December 2024
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-bone py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm prose max-w-none">
            <h2 className="font-heading text-2xl text-navy">Introduction</h2>
            <p className="font-body text-gray-600">
              DA TAXGUY & ASSOCIATES ("we," "us," or "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Information We Collect</h2>
            <p className="font-body text-gray-600">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="font-body text-gray-600">
              <li>Contact information (name, email address, phone number)</li>
              <li>Business information (business name, entity type)</li>
              <li>Information submitted through our contact forms</li>
              <li>Information uploaded through our secure client portal</li>
              <li>Communications you send to us</li>
            </ul>

            <h2 className="font-heading text-2xl text-navy mt-8">How We Use Your Information</h2>
            <p className="font-body text-gray-600">
              We use the information we collect to:
            </p>
            <ul className="font-body text-gray-600">
              <li>Provide tax preparation and accounting services</li>
              <li>Respond to your inquiries and communications</li>
              <li>Send you updates about our services (with your consent)</li>
              <li>Improve our website and services</li>
              <li>Comply with legal and regulatory requirements</li>
            </ul>

            <h2 className="font-heading text-2xl text-navy mt-8">Client Portal Security</h2>
            <p className="font-body text-gray-600">
              We use secure, encrypted client portals for the transmission and storage of sensitive documents. All tax documents, financial information, and personally identifiable information should be uploaded through the portal—never sent via email.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Cookies and Tracking</h2>
            <p className="font-body text-gray-600">
              Our website may use cookies and similar technologies to improve your browsing experience. You can control cookie settings through your browser preferences.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Information Sharing</h2>
            <p className="font-body text-gray-600">
              We do not sell your personal information. We may share your information with:
            </p>
            <ul className="font-body text-gray-600">
              <li>Service providers who assist us in delivering our services</li>
              <li>Government agencies when required by law (e.g., IRS filings)</li>
              <li>Professional advisors as necessary</li>
            </ul>

            <h2 className="font-heading text-2xl text-navy mt-8">Data Retention</h2>
            <p className="font-body text-gray-600">
              We retain client information for the period necessary to fulfill the purposes outlined in this policy and as required by applicable laws and professional standards.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Your Rights</h2>
            <p className="font-body text-gray-600">
              You may have rights regarding your personal information, including the right to access, correct, or delete your information. Contact us to exercise these rights.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Contact Us</h2>
            <p className="font-body text-gray-600">
              If you have questions about this Privacy Policy, please contact us:
            </p>
            <p className="font-body text-gray-600">
              Email: INFO@DATAXGUY.COM<br />
              Phone: 201-253-7674
            </p>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <Button
                asChild
                variant="outline"
                className="rounded-full"
              >
                <Link to="/contact">
                  Contact Us With Questions
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
